<template>
  <div class="Page404 min100vh">
    <div class="container">
      <div class="content">
        <h1>{{ error?.statusCode || 404 }}</h1>
        <p>
          {{ error?.statusCode !== 404 ? error.message : content.description }}
        </p>
        <BaseButton
          class="w400"
          :text="content.button_text || 'Back to home'"
          icon="IconArrowRight"
          tag="router-link"
          to="/"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BaseButton } from "#components";

defineOptions({
  name: "Page404",
});

defineProps({
  content: {
    type: Object,
    default: () => {},
  },
  error: {
    type: Object,
    default: () => {},
  },
});
const store = useLayoutStore();
</script>

<style lang="scss" scoped>
.Page404 {
  position: relative;
  display: flex;
  align-items: center;
}
.content {
  text-align: center;
  color: $white;
  font-size: toRem(30);
  font-style: normal;
  font-weight: 500;
  line-height: toRem(29);
  h1 {
    font-family: "Big Shoulders Display";
    font-size: toRem(238);
    font-style: normal;
    font-weight: 900;
    line-height: 1;
    margin-bottom: toRem(12);
    text-transform: uppercase;
  }
  .button {
    margin-top: toRem(10);
  }

  @media (max-width: $tablet2) {
    font-size: toRem(20);
    font-style: normal;
    line-height: toRem(22);
    h1 {
      font-size: toRem(174);
    }
    .button {
      width: auto;
      margin-top: toRem(4);
      min-width: toRem(260);
      font-size: toRem(24);
      font-weight: 600;
    }
  }
}
</style>
